/**
 * Who gets the owner's page for an invention. Anyone who can read an invention but does not own
 * it (a disclosure recipient, a collaborator) belongs on the read-only shared view; owners,
 * portfolio (aggregator) readers and platform admins keep the page they already had.
 *
 * Story #6757: an aggregator MEMBERSHIP is not proof of a portfolio grant. When the server says the
 * caller got in as a collaborator (`accessVia`), they go to the shared view whatever memberships
 * they hold. An older backend that does not send it keeps the previous behaviour.
 */
export function shouldUseSharedView(args: {
  projectId?: string
  hasProject: boolean
  userId?: string
  isOwner: boolean
  hasAggregatorAccess: boolean
  isPlatformAdmin: boolean
  accessVia?: 'owner' | 'admin' | 'portfolio' | 'collaborator'
}): boolean {
  const portfolioReader = args.hasAggregatorAccess && args.accessVia !== 'collaborator'
  return !!args.projectId && args.hasProject && !!args.userId && !args.isOwner && !portfolioReader && !args.isPlatformAdmin
}
